import React from "react";
import { useSelector } from "react-redux";
// import {Spinner} from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { CircularProgress, Grid } from "@mui/material";
import { CODEMP_MUSIMUNDO } from "../utilities";

function Spinner() {
    const { codemp } = useSelector(state => state.adminReducer.login);
    return (
        <div
            class="d-flex justify-content-center align-items align-items-center lead text-primary"
            style={{ width: '100vw', height: '100vh' }}>
            {
                !codemp ?
                    <CircularProgress color={'gray'} />
                    :
                    <CircularProgress color={CODEMP_MUSIMUNDO.includes(codemp) ? 'secondary' : 'blue'} />
            }
        </div>

    );
};

export default Spinner;